// extracted by mini-css-extract-plugin
module.exports = {"section":"cartSummary_section__pXeRA","priceDetails":"cartSummary_priceDetails__1mG7I","orderBtn":"cartSummary_orderBtn__qDbzr"};